<template>
  <el-table-column class-name="minus">
    <template slot-scope="scope">
      <template v-if="addRowMode">
        <el-col class="delete-row">
          <!-- <el-button type="danger" :disabled="!deletable(addRowMode, deleteCase, tableDataCount, scope.$index)" @click="clickDeleteRow(scope.$index)" circle icon="el-icon-minus"></el-button> -->
          <el-button type="danger" v-if="deletable(addRowMode, deleteCase, tableDataCount, scope.$index)" @click="clickDeleteRow(scope.$index)" circle icon="el-icon-minus"></el-button>
        </el-col>
      </template>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    addRowMode: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Function,
      default: () => true
    },
    deleteCase: {
      type: String,
      default: ''
    },
    tableDataCount: {
      type: Number,
      default: 0
    },
    tableDataName: {
      type: String,
      default: 'tableData'
    }
  },
  methods: {
    clickDeleteRow (index) {
      // var data = this.tableData
      this.$emit('delete-row', this.tableDataName, index)
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.minus {
      width: 6.5em;
    }
  }
}
</style>
